module.exports = __webpack_public_path__ + "img/ring_skip_0_0_0@2x.8665c2cd.png";